import axios from '@axios'

export const state = {
  noteToClients: [],
}

export const getters = {
  allNoteToClients: (state) => state.noteToClients,
}

export const mutations = {
  GET_NOTE_TO_CLIENTS: (state, resp) => {
    if (!resp) return null
    state.noteToClients = resp.noteToClients || []
  },
  UPDATE_NOTE_TO_CLIENTS: (state, resp) => {
    if (!resp) return null
    state.noteToClients = resp.noteToClients
  },
  CREATE_NOTE_TO_CLIENTS: (state, resp) => {
    if (!resp) return null
    state.noteToClients.unshift(resp.noteToClient || resp)
  },
  DELETE_NOTE_TO_CLIENTS: (state, noteToClients) => {
    state.noteToClients = state.noteToClients.filter(
      (w) => w.id !== noteToClients.id
    )
  },
  MARK_NOTES_AS_VIEWED: (state, carId) => {
    state.noteToClients.forEach((note) => {
      if (note.car.id === carId) {
        note.status = false
      }
    })
  },
}

export const actions = {
  async getNoteToClients({ commit }, params) {
    await axios
      .get(`/api/note-to-clients`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_NOTE_TO_CLIENTS', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_NOTE_TO_CLIENTS',
          err.response.status === 404 ? { noteToClients: [] } : null
        )
      })
  },
  async createNoteToClient({ commit, dispatch }, payload) {
    return axios.post(`/api/note-to-client/${payload.carId}`, payload)
  },
  async deleteNoteToClient({ commit, dispatch }, noteToClients) {
    await axios
      .delete(`/api/note-to-client/${noteToClients.id}`, {
        data: noteToClients,
      })
      .then((resp) => {
        if (resp.status === 204) {
          commit('DELETE_NOTE_TO_CLIENTS', noteToClients)
          let notification = {
            id: Date.now(),
            type: 'success',
            title: 'DELETE',
            message: 'The state has been deleted',
          }
          dispatch('notification/addNotification', notification, { root: true })
        }
      })
  },
  async updateNoteToClient({ commit }, noteToClients) {
    return axios.put(`/api/note-to-client/${noteToClients.id}`, noteToClients)
  },
  async getNoteToClientsByCarId({ commit }, { carId }) {
    return axios
      .get(`/api/note-to-client/${carId}`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_NOTE_TO_CLIENTS', resp.data)
        }
      })
      .catch((err) => {
        console.error(err)
        commit('GET_NOTE_TO_CLIENTS', { noteToClients: [] })
      })
  },
}
